let filterButtons = document.querySelectorAll('.qna-filter__button');
let filterAllButton = document.querySelector('.qna-filter__button[data-category="all"]');
let qnaItems = document.querySelectorAll('.qna-item');
let qnasSearch = document.getElementById('qna-search');


if ( qnasSearch && qnaItems.length > 0 ) {
	qnasSearch.addEventListener('input', function(e) {
		e.preventDefault();

		let activeCategories = getActiveCategories();
		let filtered = filterqnasByCategory(qnaItems, activeCategories);

		qnaItems.forEach(function(qna) {
			qna.style.display = 'none';

			if ( filtered.includes(qna)) {
				qna.style.display = 'block';
			}
		});
	});

	filterButtons.forEach(function(button) {
		button.addEventListener('click', function(e) {
			e.preventDefault();

			toggleFilterButtons(button);

			let activeCategories = getActiveCategories();
			let filtered = filterqnasByCategory(qnaItems, activeCategories);

			qnaItems.forEach(function(qna) {
				qna.style.display = 'none';

				if ( filtered.includes(qna)) {
					qna.style.display = 'block';
				}
			});
		});
	});
}

function toggleFilterButtons(button) {
	// If the "all" button is pressed, deactivate all other buttons
	if ( button.dataset.category === 'all') {
		filterButtons.forEach(function(filterButton) {
			filterButton.dataset.active = 'false';
		});
	}

	// If any other filterButton is pressed, deactivate the "all" button
	// then toggle the state of the button that was pressed
	filterAllButton.dataset.active = 'false';

	if ( button.dataset.active === 'false') {
		button.dataset.active = 'true';
	} else {
		button.dataset.active = 'false';
	}

	// If all buttons are inactive, activate the "all" button
	let activeButtons = document.querySelectorAll('.qna-filter__button[data-active="true"]');
	if ( activeButtons.length === 0) {
		filterAllButton.dataset.active = 'true';
	}
};

function getActiveCategories() {
	let activeFilterButtons = document.querySelectorAll('.qna-filter__button[data-active="true"]');

	let activeCategories = [];

	activeFilterButtons.forEach(function(button) {
		let category = button.dataset.category;

		if ( category !== 'all') {
			activeCategories = [...new Set([...activeCategories, category])];
		}
	});

	return activeCategories;
}


function filterqnasByCategory(qnas, activeCategories) {
	if (activeCategories.length === 0 && qnasSearch.value.trim().length === 0) {
		return Array.from(qnas);
	}

	let filteredqnas = [];

	qnas.forEach(function(qna) {
			let hasActiveCategory = false;
			let matchesKeyword = false;

			// Match on category
			if (activeCategories.length > 0) {
					let qnaCategories = qna.dataset.categories.split(',');

					hasActiveCategory = activeCategories.some(function(category) {
							return qnaCategories.includes(category);
					});
			}

			// Match on keyword
			if (qnasSearch.value.trim().toLowerCase().length > 0) {
					let title = qna.querySelector('.qna-item__title').innerText.toLowerCase();
					let content = qna.querySelector('.qna-item__content').innerHTML.toLowerCase();
					let keyword = qnasSearch.value.toLowerCase();

					matchesKeyword = title.includes(keyword) || content.includes(keyword);
			}

			// Only add to filteredqnas if it matches both category and keyword, or one of them if the other is not present
			if ((hasActiveCategory && matchesKeyword) || (hasActiveCategory && qnasSearch.value.trim().length === 0) || (matchesKeyword && activeCategories.length === 0)) {
					filteredqnas.push(qna);
			}
	});

	return filteredqnas;
}
